module.exports = __webpack_public_path__ + "img/male2.dee2deda.jpeg";